import { useEffect, useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireBranch = true, allow, feature }) {
  const { user, branch } = useAuth();
  const location = useLocation();
  const flagged = feature && user && user.feature_flags && user.feature_flags[feature] === false;
  const toastedRef = useRef(false);
  useEffect(() => {
    if (flagged && !toastedRef.current) {
      toast.error("This feature is turned off for your account. Ask your superadmin.");
      toastedRef.current = true;
    }
  }, [flagged]);

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-warm-sand" data-testid="auth-loading">
        <div className="text-forest text-sm ornament-dot">Loading…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (allow && !allow.includes(user.role) && user.role !== "superadmin") {
    return <Navigate to="/dashboard" replace />;
  }
  if (flagged) return <Navigate to="/dashboard" replace />;
  if (requireBranch && !branch) {
    return <Navigate to="/select-branch" replace />;
  }
  return children;
}
